import React, { useCallback, useEffect, useState } from 'react';
import { Box, Container, TextField, Typography } from '@mui/material';
import { useSnackbar } from 'notistack';
import api, { ENGINE } from '../../infrastructure/config/api';
import Button from '../components/common/Button';
import { EngineSignalTable } from '../components/engine';

const EngineSignals = () => {
  const { enqueueSnackbar } = useSnackbar();
  const [symbols, setSymbols] = useState('BTCUSDT');
  const [timeframe, setTimeframe] = useState('15m');
  const [loading, setLoading] = useState(false);
  const [rows, setRows] = useState([]);

  const fetchSignals = useCallback(async () => {
    setLoading(true);
    try {
      const response = await api.get(ENGINE.SIGNALS, {
        params: { symbols, timeframe },
      });
      setRows(response.data?.data || []);
    } catch (error) {
      enqueueSnackbar(error.response?.data?.error || 'Failed to load engine signals', {
        variant: 'error',
      });
    } finally {
      setLoading(false);
    }
  }, [enqueueSnackbar, symbols, timeframe]);

  useEffect(() => {
    fetchSignals();
  }, [fetchSignals]);

  return (
    <Container maxWidth="xl" sx={{ mt: 4, mb: 6 }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
        <Typography variant="h4">Engine Signals</Typography>
      </Box>

      <Box sx={{ display: 'flex', gap: 2, mb: 3, flexWrap: 'wrap' }}>
        <TextField
          label="Symbols (comma-separated)"
          size="small"
          value={symbols}
          onChange={(e) => setSymbols(String(e.target.value || '').toUpperCase())}
          sx={{ minWidth: 320 }}
        />
        <TextField
          label="Timeframe"
          size="small"
          value={timeframe}
          onChange={(e) => setTimeframe(e.target.value)}
        />
        <Button variant="contained" onClick={fetchSignals} loading={loading}>Refresh</Button>
      </Box>

      <EngineSignalTable rows={rows} />
    </Container>
  );
};

export default EngineSignals;
